/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: 'Plannen namens',
  scheduleForAssistedUser: 'Meetinginstellingen bijwerken namens {userName}.',
  scheduleForGuidance:
    'Plannen namens iemand anders?\n1. Zorg dat u toegang hebt tot zijn of haar Outlook Agenda.\n2. Selecteer in de vervolgkeuzelijst de persoon voor wie u plant.\n',
  scheduleForGuidanceMore: 'Meer informatie',
  meetingSettings: 'Meetinginstellingen',
  meetingSettingsDescription:
    'Updates zijn alleen van toepassing op deze meeting.',
  [ASSISTED_USERS_MYSELF]: 'Mezelf',
  waitingRoomTitle: 'Wachtkamer gebruiken',
  waitingRoomDescription:
    'Deelnemers wachten tot u ze toelaat. Geweldig voor sollicitatiegesprekken of deelnemers van buitenaf.',
  waitingRoomNotCoworker: 'Voor iedereen buiten mijn bedrijf',
  waitingRoomGuest: 'Voor iedereen die niet is aangemeld',
  waitingRoomAll: 'Voor alle deelnemers',
  enterPassword: 'Wachtwoord invoeren',
  onlyJoinAfterMe: 'Meeting starten nadat u deelneemt',
  allowJoinBeforeHostDescription:
    'De meeting start nadat u deelneemt om vroegtijdige gesprekken te voorkomen.',
  requirePassword: 'Wachtwoord verplichten',
  requirePasswordDescription:
    'Houd uw meeting veilig. Iedereen die de link gebruikt, wordt niet om een wachtwoord gevraagd.',
  password: 'Wachtwoord:',
  passwordEmptyError: 'Wachtwoord meeting vereist',
  passwordInvalidError:
    'Uw wachtwoord moet 1-10 letters en cijfers lang zijn, maar mag geen symbolen bevatten',
  passwordHintText:
    'Uw wachtwoord moet 1-10 letters en cijfers lang zijn, maar mag geen symbolen bevatten.',
  usePersonalMeetingIdInstead: 'Link persoonlijke meeting gebruiken',
  allowMeetingAccess: 'Beheren wie kan deelnemen',
  anyoneWithLink: 'Iedereen met een link',
  signedInUsers: 'Alleen {shortName}-accounts',
  signedInCoWorkers: "Alleen mijn collega's",
  passwordLabel: 'Wachtwoord',
  edit: 'Bewerken',
  editSettings: 'Instellingen bewerken',
  lockTooltip: 'Deze instelling wordt beheerd door uw bedrijfsbeheerder',
  cancel: 'Annuleren',
  update: 'Bijwerken',
  pmiSettingsTitle: 'Instellingen voor persoonlijke meeting',
  pmiSettingsDescription:
    'Stel voor uw persoonlijke meetinglink in wie kan deelnemen en hoe.',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
